import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Divider } from "@material-ui/core";
// import ExpansionPanel from "@material-ui/core/ExpansionPanel";
// import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
// import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Markdown from "markdown-to-jsx";
import Link from "@material-ui/core/Link";
/* eslint import/no-webpack-loader-syntax: off */
import Apps from "!raw-loader!./Exercise13/Apps.md";

const styles = theme => ({
  card: {
    minWidth: 275
  },
  para: {
    fontSize: 16
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    maxWidth: "80%"
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});
function SimpleCard(props) {
  const { classes } = props;

  const mdconfig = {
    overrides: {
      h1: {
        component: Typography,
        props: {
          variant: "h5",
          color: "primary"
        }
      },
      h2: {
        component: Typography,
        props: {
          variant: "h6",
          color: "secondary"
        }
      },
      h3: {
        component: Typography,
        props: {
          variant: "h6",
          color: "textSecondary",
          className: classes.para
        }
      },
      a: {
        component: Link,
        props: {
          target: "_blank",
          color: "secondary"
        }
      },
      p: {
        component: Typography,
        props: {
          paragraph: true,
          className: classes.para
        }
      },
      ul: {
        component: Typography,
        props: {
          component: "ul",
          className: classes.para
        }
      },
      em: {
        props: {
          className: classes.para
        }
      },
      pre: {
        props: {
          // className: "w3-panel w3-card w3-light-grey"
          className: "w3-card "
        }
      },
      code: {
        props: {
          className: "w3-code jsHigh notranslate"
        }
      }
    }
  };

  return (
    <div>
      <Card className={classes.card}>
        <CardContent>
          <Typography
            className={classes.title}
            color="textSecondary"
            gutterBottom
          >
            Apr 10, 2019
          </Typography>
          <Typography variant="h5" component="h2">
            Applications and Implications
          </Typography>
          <Typography className={classes.pos} color="textSecondary">
            electronics, test equipment, consumer electronics, phone, terminal,
            laptop, network, satellite, machines, robots, inflatables boats,
            bicycles, drones, cars, environment, energy, food, biology,
            microscope, prosthetics, shoes, clothes, toys, art, musical,
            instruments, furniture, houses, labs, communities, cities,
            economies.
          </Typography>
          <Typography component="p">
            individual assignment:
            <br />
            {
              '"Propose a final project masterpiece that integrates the range of units covered"'
            }
          </Typography>
        </CardContent>
        <CardActions>
          <Button
            href="http://academy.cba.mit.edu/classes/applications_implications/index.html"
            target="_blank"
            size="small"
          >
            Learn More
          </Button>
        </CardActions>
        <Divider />
      </Card>
      <br />
      <div className={classes.root}>
        <Card className={classes.card}>
          <CardContent>
            <Markdown options={mdconfig}>{Apps}</Markdown>
          </CardContent>
        </Card>
        {/* <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              DHT22 - Humidity, Temperature
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Markdown options={mdconfig}>{DHT22}</Markdown>
          </ExpansionPanelDetails>
        </ExpansionPanel>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Typography className={classes.heading}>
              MQ-135 Gas Sensor
            </Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Markdown options={mdconfig}>{MQ135}</Markdown>
          </ExpansionPanelDetails>
        </ExpansionPanel> */}
      </div>
    </div>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleCard);
